const ArrangeSquare = ({
  width = 24,
  height = 24,
  fill = "currentColor",
  ...props
}) => (
  <svg
    {...props}
    width={width}
    height={height}
    fill={fill}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H15C20.43 1.25 22.75 3.57 22.75 9V15C22.75 20.43 20.43 22.75 15 22.75ZM9 2.75C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V9C21.25 4.39 19.61 2.75 15 2.75H9Z"
      fill={fill}
    />
    <path
      d="M14.1098 17.61C13.9198 17.61 13.7298 17.54 13.5798 17.39C13.2898 17.1 13.2898 16.62 13.5798 16.33L16.6198 13.29C16.9098 13 17.3898 13 17.6798 13.29C17.9698 13.58 17.9698 14.06 17.6798 14.35L14.6398 17.39C14.4998 17.53 14.3098 17.61 14.1098 17.61Z"
      fill={fill}
    />
    <path
      d="M17.1501 14.5701H6.8501C6.4401 14.5701 6.1001 14.2301 6.1001 13.8201C6.1001 13.4101 6.4401 13.0701 6.8501 13.0701H17.1601C17.5701 13.0701 17.9101 13.4101 17.9101 13.8201C17.9101 14.2301 17.5701 14.5701 17.1501 14.5701Z"
      fill={fill}
    />
    <path
      d="M6.85004 10.9301C6.66004 10.9301 6.47004 10.8601 6.32004 10.7101C6.03004 10.4201 6.03004 9.94008 6.32004 9.65008L9.36004 6.61008C9.65004 6.32008 10.13 6.32008 10.42 6.61008C10.71 6.90008 10.71 7.38008 10.42 7.67008L7.38004 10.7101C7.23004 10.8601 7.04004 10.9301 6.85004 10.9301Z"
      fill={fill}
    />
    <path
      d="M17.1501 10.9302H6.8501C6.4401 10.9302 6.1001 10.5902 6.1001 10.1802C6.1001 9.77018 6.4401 9.43018 6.8501 9.43018H17.1601C17.5701 9.43018 17.9101 9.77018 17.9101 10.1802C17.9101 10.5902 17.5701 10.9302 17.1501 10.9302Z"
      fill={fill}
    />
  </svg>
);

export default ArrangeSquare;
